function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Table } from '@rd-web-markets/shared/dist/util';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import { TextFormFieldRow, IntegerFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import deminimisSubsidyService, { DEMINIMIS_SUBSIDY_TYPE } from '../../../services/company/deminimis_subsidy.service';
import './DeminimisSubsidy.css';
const isExplanation2 = s => s.subsidy_type === 'explanation_2' || s.subsidy_type === DEMINIMIS_SUBSIDY_TYPE.explanation_2;
const isExplanation3 = s => s.subsidy_type === 'explanation_3' || s.subsidy_type === DEMINIMIS_SUBSIDY_TYPE.explanation_3;
const isPendingSubsidy = s => (s === null || s === void 0 ? void 0 : s.isPendingRow) === true;
const newPendingId = () => "".concat(Date.now(), "-").concat(Math.random());
const emptyPendingSubsidy = subsidyType => ({
  subsidy_date: null,
  aid_providers: '',
  aid_value: '',
  subsidy_type: subsidyType,
  saved: true,
  isPendingRow: true
});
const DeminimisSubsidy = _ref => {
  let {
    elsterId,
    regulation,
    setRegulation,
    setLoading
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    createSubsidy,
    updateSubsidy,
    deleteSubsidy
  } = deminimisSubsidyService.useCrud(elsterId, setLoading, setRegulation);

  // to display records that are not saved yet at the bottom of the tables
  const [pendingRows, setPendingRows] = useState([]);
  const subsidiesExplanation2 = useMemo(() => {
    const subsidies_explanation2 = ((regulation === null || regulation === void 0 ? void 0 : regulation.deminimis_subsidies) || []).filter(isExplanation2);
    const pending = pendingRows.filter(p => p.subsidy_type === 'explanation_2' || p.subsidy_type === DEMINIMIS_SUBSIDY_TYPE.explanation_2);
    return [...subsidies_explanation2, ...pending];
  }, [regulation === null || regulation === void 0 ? void 0 : regulation.deminimis_subsidies, pendingRows]);
  const subsidiesExplanation3 = useMemo(() => {
    const subsidies_explanation3 = ((regulation === null || regulation === void 0 ? void 0 : regulation.deminimis_subsidies) || []).filter(isExplanation3);
    const pending = pendingRows.filter(p => p.subsidy_type === 'explanation_3' || p.subsidy_type === DEMINIMIS_SUBSIDY_TYPE.explanation_3);
    return [...subsidies_explanation3, ...pending];
  }, [regulation === null || regulation === void 0 ? void 0 : regulation.deminimis_subsidies, pendingRows]);
  const handleChange = useCallback((subsidy, field, value) => {
    const subsidyId = subsidy.id;
    if (isPendingSubsidy(subsidy)) {
      setPendingRows(prev => prev.map(p => p.id === subsidyId ? _objectSpread(_objectSpread({}, p), {}, {
        [field]: value,
        saved: false
      }) : p));
      return;
    }
    setRegulation(prev => {
      if (!prev) return prev;
      const list = prev.deminimis_subsidies || [];
      return _objectSpread(_objectSpread({}, prev), {}, {
        deminimis_subsidies: list.map(s => s.id === subsidyId ? _objectSpread(_objectSpread({}, s), {}, {
          [field]: value,
          saved: false
        }) : s)
      });
    });
  }, [setRegulation]);
  const handleAdd = useCallback(subsidyType => {
    if ((regulation === null || regulation === void 0 ? void 0 : regulation.id) == null) return;
    const id = newPendingId();
    const typeForRow = subsidyType === DEMINIMIS_SUBSIDY_TYPE.explanation_2 || subsidyType === 'explanation_2' ? 'explanation_2' : 'explanation_3';
    setPendingRows(prev => [...prev, _objectSpread({
      id
    }, emptyPendingSubsidy(typeForRow))]);
  }, [regulation === null || regulation === void 0 ? void 0 : regulation.id]);
  const handleDelete = useCallback(async subsidy => {
    if (isPendingSubsidy(subsidy)) {
      setPendingRows(prev => prev.filter(p => p.id !== subsidy.id));
      return;
    }
    await deleteSubsidy(subsidy);
  }, [deleteSubsidy]);
  const upsert = useCallback(async subsidy => {
    var _subsidy$subsidy_date2, _subsidy$aid_provider2;
    if (subsidy.saved !== false) return;
    if (isPendingSubsidy(subsidy)) {
      var _subsidy$subsidy_date, _subsidy$aid_provider;
      if ((regulation === null || regulation === void 0 ? void 0 : regulation.id) == null) return;
      await createSubsidy({
        deminimis_subsidy: {
          deminimis_regulation_id: regulation.id,
          subsidy_type: subsidy.subsidy_type,
          subsidy_date: (_subsidy$subsidy_date = subsidy.subsidy_date) !== null && _subsidy$subsidy_date !== void 0 ? _subsidy$subsidy_date : null,
          aid_providers: (_subsidy$aid_provider = subsidy.aid_providers) !== null && _subsidy$aid_provider !== void 0 ? _subsidy$aid_provider : '',
          aid_value: subsidy.aid_value
        }
      });
      setPendingRows(prev => prev.filter(p => p.id !== subsidy.id));
      return;
    }
    await updateSubsidy({
      id: subsidy.id,
      deminimis_subsidy: {
        subsidy_type: subsidy.subsidy_type,
        subsidy_date: (_subsidy$subsidy_date2 = subsidy.subsidy_date) !== null && _subsidy$subsidy_date2 !== void 0 ? _subsidy$subsidy_date2 : null,
        aid_providers: (_subsidy$aid_provider2 = subsidy.aid_providers) !== null && _subsidy$aid_provider2 !== void 0 ? _subsidy$aid_provider2 : '',
        aid_value: subsidy.aid_value
      }
    });
  }, [createSubsidy, regulation === null || regulation === void 0 ? void 0 : regulation.id, updateSubsidy]);
  const persistIfUnsaved = useCallback(subsidy => {
    if (subsidy.saved === false) upsert(subsidy);
  }, [upsert]);
  const buildRows = useCallback(subsidies => subsidies.map(subsidy => {
    var _subsidy$aid_provider3;
    return {
      key: "deminimis-subsidy-".concat(subsidy.id),
      data: {
        subsidy
      },
      customTdClass: subsidy.saved === false ? 'deminimis-subsidy-row--unsaved' : '',
      columns: [/*#__PURE__*/React.createElement(DatePicker, {
        key: "date-".concat(subsidy.id),
        selected: subsidy.subsidy_date,
        onChange: value => handleChange(subsidy, 'subsidy_date', value),
        onBlur: () => persistIfUnsaved(subsidy),
        "data-testid": "deminimis_subsidy_subsidy_date_".concat(subsidy.id)
      }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
        renderLabel: false,
        key: "aid_providers-".concat(subsidy.id),
        fieldName: "aid_providers",
        label: "",
        value: (_subsidy$aid_provider3 = subsidy.aid_providers) !== null && _subsidy$aid_provider3 !== void 0 ? _subsidy$aid_provider3 : '',
        onChange: e => handleChange(subsidy, 'aid_providers', e.target.value),
        onBlur: () => persistIfUnsaved(subsidy),
        marginClass: "mb-0",
        labelColSpan: 2,
        dataTestId: "deminimis_subsidy_aid_providers_".concat(subsidy.id),
        as: "textarea",
        rows: 2,
        formGroupClasses: "align-items-center"
      }), /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
        key: "aid_value-".concat(subsidy.id),
        fieldName: "aid_value",
        value: subsidy.aid_value != null && subsidy.aid_value !== '' ? String(subsidy.aid_value) : '',
        onChange: e => handleChange(subsidy, 'aid_value', e.target.value),
        onBlur: () => persistIfUnsaved(subsidy),
        dataTestId: "deminimis_subsidy_aid_value_".concat(subsidy.id)
      }), /*#__PURE__*/React.createElement("span", {
        key: "save-hint-".concat(subsidy.id),
        className: "text-muted small",
        style: {
          display: 'inline-block',
          maxWidth: '150px'
        }
      }, subsidy.saved === false ? t('click_outside_to_save') : null)]
    };
  }), [handleChange, persistIfUnsaved, t]);
  const headers = useMemo(() => [{
    text: t('subsidy_date'),
    width: '140px'
  }, {
    text: t('aid_providers'),
    width: '300px'
  }, {
    text: t('aid_value'),
    width: '120px'
  }, {
    text: '',
    width: '150px'
  }, {
    text: '',
    width: '90px'
  }], [t]);
  const onDeleteRow = useCallback((_index, row) => {
    handleDelete(row.data.subsidy);
  }, [handleDelete]);
  const renderTableSection = (titleKey, subsidyType, rows) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center mt-4 mb-2"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, t(titleKey))), /*#__PURE__*/React.createElement(Col, {
    className: "text-end"
  }, /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    isImmutableUnderReview: true,
    disabled: (regulation === null || regulation === void 0 ? void 0 : regulation.id) == null,
    onClick: () => handleAdd(subsidyType),
    style: {
      marginRight: '10px'
    },
    text: t('add_subsidy')
  }))), /*#__PURE__*/React.createElement(Table, {
    style: {
      minHeight: '100px'
    },
    headers: headers,
    rows: buildRows(rows),
    onDelete: onDeleteRow,
    showControls: true,
    opts: {
      responsive: true,
      hover: true
    }
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTableSection('dmver_erklarung_2', 'explanation_2', subsidiesExplanation2), renderTableSection('dmver_erklarung_3', 'explanation_3', subsidiesExplanation3));
};
export default DeminimisSubsidy;